<template>
  <v-dialog persistent max-width="600px" scrollable v-model="active">
    <v-card height="500px">
      <v-card-title class="ma-0 pa-0">
        <v-row class="ma-0 pa-0 mt-3" justify="start">
          <v-col cols="3" class="ma-0 pa-0">
            <v-row class="ma-0 pa-0" justify="start" align="center">
              <v-btn
                @click="
                  () => {
                    file = null;
                    active = false;
                  }
                "
                text
                class="text-none primary--text"
                >{{ labels.CLOSE }}
              </v-btn>
            </v-row>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-row
              justify="center"
              align="center"
              class="vetalfa-row ma-0 pa-0 px-4"
            >
              <p class="text-center vetalfa-dialog-title pt-1 pa-0 ma-0">
                Adição de Tabelas
              </p>
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="ma-0 pa-0 py-4">
        <vetalfa-section-title prop="Observações" class="ma-0 pa-0">
          <v-row class="ma-0 pa-2">
            <v-textarea
              outlined
              value="Adicione apenas arquivos excel no formato correto (.xlsx). Evite deixar células em branco principalmente no cabeçalho da tabela. A primeira linha do excel será considerada como o cabeçalho da tabela. O preenchimento da primeira linha é obrigatório."
              :auto-grow="true"
              readonly
              disabled
              hide-details
            >
            </v-textarea>
          </v-row>
        </vetalfa-section-title>
        <vetalfa-section-title
          prop="Selecione o excel que você deseja adicionar:"
          class="ma-0 pa-0"
        >
          <v-row class="ma-0 pa-0 pa-2">
            <v-col cols="12" class="ma-0 pa-0 px-2">
              <v-file-input
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                label="Anexar arquivo excel (.xlsx)"
                v-model="file"
                :loading="!table && file"
                hide-details
                dense
                outlined
              ></v-file-input>
            </v-col>
            <v-col cols="12" class="ma-0 pa-0 mt-4 px-2">
              <v-text-field
                v-model="caption"
                outlined
                dense
                label="Legenda (Opcional)"
              ></v-text-field>
            </v-col>
          </v-row>
        </vetalfa-section-title>
        <vetalfa-section-title
          prop="Tabela selecionada:"
          class="ma-0 pa-0"
          v-if="table"
        >
          <v-row class="ma-0 pa-0 pa-2">
            <v-col cols="12" class="ma-0 pa-2">
              <v-simple-table height="500px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th
                        class="text-left"
                        v-for="header in table.headers"
                        :key="header"
                      >
                        {{ header }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(line, index) in table.lines"
                      :key="`table-line${index}`"
                    >
                      <td
                        v-for="(column, index) in line"
                        :key="`${column}-${index}`"
                      >
                        {{ column }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </vetalfa-section-title>
      </v-card-text>
      <v-card-actions class="ma-0 pa-0 pa-2">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!table"
          class="primary white--text text-none"
          @click="
            setFinalTable({
              ...table,
              caption: caption,
            })
          "
        >
          Salvar e adicionar tabela
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import readXlsxFile from "read-excel-file";
import labels from "@/constants/labels.js";
export default {
  data() {
    return {
      file: null,
      caption: "",
      labels,
    };
  },
  methods: {
    ...mapMutations("management", [
      "setTableModal",
      "setTable",
      "setFinalTable",
    ]),
    ...mapActions("management", ["processExcelResult"]),
  },
  computed: {
    ...mapGetters("management", [
      "tableModal",
      "selectedSection",
      "table",
      "finalTable",
    ]),
    ...mapGetters("drugs", ["drug", "product", "dose"]),
    active: {
      get() {
        return this.tableModal;
      },
      set(val) {
        this.setTableModal(val);
      },
    },
  },
  watch: {
    tableModal() {
      this.setTable(null);
    },
    file(val) {
      if (val) {
        readXlsxFile(val).then((rows) => {
          this.processExcelResult({
            rows,
            caption: this.caption,
            name: val.name,
          });
        });
      } else {
        this.setTable(null);
      }
    },
    finalTable(val) {
      if (val) {
        this.file = null;
        this.caption = "";
      }
    },
  },
};
</script>